var options = {  
    port:  37900,
    host: "wss://hairdresser.cloudmqtt.com",
    clientId: "mqttjs_" + Math.random().toString(16).substr(2, 8),
    username: "aoaljzzp",
    password: "U1rrWLMwGVo6",
  };

export default options;